// extracted by mini-css-extract-plugin
export default {"success":"DisplayErrorMessage_success__yl5O+","error":"DisplayErrorMessage_error__GGDmG"};